<template>
    <validation-observer ref="form" v-slot="{ handleSubmit, meta }">
        <modal
            :id="modalId"
            title="Add Subscription"
            ok-title="Add Subscription"
            :ok-disabled="loading || !meta.valid"
            @ok.prevent="handleSubmit(_, save)"
            @hide="hideModal"
            @show="setValues"
        >
            <busy-modal :show="loading"></busy-modal>
            <b-form @submit.prevent="handleSubmit(_, save)" v-if="values">
                <b-row>
                    <b-col>
                        <form-select
                            v-model="values.packageValue"
                            label="Package:"
                            :options="packageOptions"
                        ></form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <validation-provider name="user_id" rules="required" v-slot="{ errors, handleChange }">
                            <form-select
                                v-model="values.userValue"
                                :error="errors[0]"
                                label="User:"
                                :options="userOptions"
                                @change="handleChange"
                            ></form-select>
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <validation-provider name="status" rules="required" v-slot="{ errors, handleChange }">
                            <form-select
                                v-model="values.statusValue"
                                :error="errors[0]"
                                label="Status:"
                                :options="statusOptions"
                                @change="handleChange"
                            ></form-select>
                            <span class="text-danger">Warning: this action will cancel any existing subscription.</span>
                        </validation-provider>
                    </b-col>
                </b-row>
            </b-form>
        </modal>
    </validation-observer>
</template>

<script>
    import BusyModal from '../../../generic/busy-modal/busy-modal.vue';
    import FormSelect from '../../../generic/form-select/form-select.vue';
    import isEmpty from 'lodash/isEmpty';
    import Modal from '../../../generic/modal/modal.vue';
    import { formatResponseError } from '../../../../utils/api';
    import { SUBSCRIPTION_STATUS_MAPPING } from '../../../../constants';

    export default {
        name: 'SubscriptionCreateModalForm',
        components: {
            BusyModal,
            FormSelect,
            Modal,
        },
        props: {
            modalId: String,
            createSubscription: {
                type: Function,
                default: () => Promise.resolve(),
            },
            initialValues: {
                type: Object,
                default: () => ({}),
            },
        },
        data() {
            return {
                loading: false,
                values: this.getInitialValues(),
            };
        },
        computed: {
            packageOptions() {
                return [
                    {
                        value: 'Free package for system purpose',
                        text: 'Free package for system purpose',
                    },
                ];
            },
            statusOptions() {
                return Object.entries(SUBSCRIPTION_STATUS_MAPPING).map(([status, statusText]) => ({
                    value: status,
                    text: statusText,
                }));
            },
            userOptions() {
                return [
                    {
                        value: this.initialValues.userValue.value,
                        text: this.initialValues.userValue.text,
                    },
                ];
            },
        },
        methods: {
            getInitialValues() {
                return {
                    userValue: this.initialValues.userValue.value,
                    packageValue: 'Free package for system purpose',
                    statusValue: 'ACTIVE',
                };
            },
            setValues() {
                this.$refs.form.setValues({
                    user_id: this.values.userValue,
                    status: this.values.statusValue,
                })  
            },
            hideModal() {
                this.$bvModal.hide(this.modalId);
            },
            async save() {
                this.loading = true;

                try {
                    await this.createSubscription({
                        user_id: this.values.userValue,
                        status: this.values.statusValue,
                    });
                    this.$emit('success-create');
                    this.successToast({
                        text: `Subscription successfully added`,
                    });
                    this.$nextTick(() => {
                        this.hideModal();
                    });
                } catch (error) {
                    const { generic, fields } = formatResponseError(error);

                    if (generic) {
                        this.errorToast({ text: generic });
                    }
                    if (!isEmpty(fields)) {
                        this.$refs.form.setErrors(fields);
                    }
                } finally {
                    this.loading = false;
                }
            },
        },
    };
</script>
